import { forwardRef } from 'react';
import { getOptionStyles, getLabelStyles, getCheckboxStyles } from './MultiSelectOptionStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Option } from '../../../components/Option/Option.js';
import { Checkbox } from '../../../components/Form/Checkbox/Checkbox.js';

const MultiSelectOption = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    selected,
    disabled,
    children,
    ...rest
  } = _ref;
  const optionValue = typeof value === 'string' ? value : value.value;
  return jsx(Option, {
    ref: ref,
    value: value,
    showTick: false,
    selected: selected,
    css: getOptionStyles(disabled),
    ...rest,
    children: jsxs("label", {
      css: getLabelStyles,
      htmlFor: optionValue,
      children: [jsx(Checkbox, {
        css: getCheckboxStyles,
        disabled: disabled,
        checked: selected,
        value: optionValue,
        readOnly: true
      }), children]
    })
  });
});
MultiSelectOption.displayName = 'MultiSelectOption';

export { MultiSelectOption };
//# sourceMappingURL=MultiSelectOption.js.map
